import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Testimonial from "./Testimonial";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import "../../index.css";

const TestimonialSwiper = () => {
  const reviews = [
    {
      title: "Sapna Sanjay Suryavanshi",
      review:
        "I wanted to commend you on the exceptional job you did on the recent filling company offer letter, voting Card, ABHA card attention to detail and dedication were evident, and your contributions played a significant role in its success. Please more expand your cyber.",
    },
    {
      title: "Vishal Gupta",
      review:
        "Amazing service for graphic designing! The quality of the designs was awesome, and the charges are very reasonable. Highly recommend this place for creative work and other cyber cafe needs.",
    },
    {
      title: "Adinath Naik",
      review:
        "I would like to share my experience with other. I got best service and representative is truly helpful.",
    },
    {
      title: "Arjun Mehta",
      review:
        "Aajkal PAN card banwana ya vote ID ke liye registration karna itna aasaan nahi hota. Lekin Glory Online Cyber Cafe mein mujhe ekdum perfect service mili. Staff friendly hai aur jaldi kaam ho gaya. Thank you .",
    },
    {
      title: "Ananya Srivastava",
      review:
        "I came here for graphic designing work, and the output was fantastic! Really creative team and quick service. They understood exactly what I wanted. For all graphic needs, Glory Online Cyber Cafe is perfect!",
    },
    {
      title: "Kavita Patel",
      review:
        "Voting card banwane ke liye bahut achi jagah hai. Staff very supportive aur charges bhi low hain. Jitna timely service mila, usse main bahut khush hoon.",
    },
    {
      title: "Neha Kapoor",
      review:
        "Bahut shandar experience! Glory Cyber Cafe ke through maine PAN card apply kiya, aur process bohot hi smooth tha. Staff is very cooperative, and they made sure I understood each step. Thanks for such good service.",
    },
    {
      title: "Meena Desai",
      review:
        "Form filling aur PUC renewal services ke liye ek perfect place hai. Staff bohot friendly aur kaam mein efficient hai. Time bhi zyada nahi lagta. Will recommend this cafe to everyone needing online services.",
    },
    {
      title: "Rakesh Sharma",
      review:
        "Bahut badiya service! Maine PAN card ke liye form filling karwaya aur bohot smooth process tha. Staff bahut helpful hai, aur charges bhi reasonable hai. Highly recommended for all online services.",
    },
    {
      title: "Rajesh Verma",
      review:
        "Glory Online Cyber Cafe ki service bohot hi badiya hai! Maine yaha pe voting card ke liye apply kiya aur kuch graphic designing ka kaam bhi karwaya. Dono services top-notch thi. Staff kaafi professional aur friendly hai. Highly recommended!",
    },
  ];

  return (
    <>
      <Swiper
        navigation={true}
        modules={[Navigation, Autoplay]}
        className="swiper"
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
      >
        {reviews.map((testimonial) => (
          <SwiperSlide>
            <Testimonial review={testimonial.review} name={testimonial.title} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default TestimonialSwiper;
